module.exports = __webpack_public_path__ + "4025aa7142f2b05944a479c0f1268ce7.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_2.png
// module id = 83
// module chunks = 0